module.exports = __webpack_public_path__ + "img/pc_p3_z6.3a6e698a.png";